export default __webpack_public_path__ + "static/media/logo-part.ef4d591c.svg";